{
  "name": "@ns/transfer-node-cash-to-company",
  "version": "1.0.0",
  "description": " Transfer node cash to a company",
  "inputs": {
    "recipientCompanyId": {
      "type": "string"
    }
  },
  "outcomes": {
    "transfer": {}
  }
}
